<template>
  <v-container v-show="display" fluid grid-list-xl text-xs-center>

    <h1 v-if="isInstallerAccount()" class="page-title display-1">
      {{ isNew() ? 'Crear nuevo instalador' : 'Detalles del instalador' }}
    </h1>
    <h1 v-if="isCommerceAccount()" class="page-title display-1">
      {{ isNew() ? 'Crear nuevo comercio' : 'Detalles del comercio' }}
    </h1>
    <h1 v-if="isAdminAccount()" class="page-title display-1">
      {{ isNew() ? 'Crear nuevo administrador' : 'Detalles del administrador' }}
    </h1>
    <h1 v-if="isManagerAccount()" class="page-title display-1">
      {{ isNew() ? 'Crear nuevo gerente' : 'Detalles del gerente' }}
    </h1>
    <h1 v-if="isResponsibleAccount()" class="page-title display-1">
      {{ isNew() ? 'Crear nuevo encargado' : 'Detalles del encargado' }}
    </h1>
    <v-layout row justify-space-between  wrap>
      <v-flex xs12 sm12 md5 lg5 xl5>

      <vuetify-avatar-card
        :color="'primary'"
        :avatar="avatar || {}"
        :avatars="avatars || []"
        @on-upload-error="onUploadError"
        @on-change-avatar="onChangeAvatar"
      >
        <v-layout slot="card-title" column align-center justify-center>
          <v-layout class="column avatar-info" align-center justify-center>
            <div v-if="isInstallerAccount() || isAdminAccount() || isSuperadminAccount()" class="headline">
              {{ (name.value || '') + ' ' + (surname.value || '') }}
            </div>
            <div v-if="isCommerceAccount()" class="headline">
              {{ name.value || '' }}
            </div>
            <span v-show="username.value" class="section primary--text">@{{ username.value }}</span>
          </v-layout>
        </v-layout>
        <visible-for superadmin administrator supervisor installer commerce slot="card-text">
          <div slot="content">
            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                v-if="status.value < 3 && (isSuperadmin() || (isAdmin() && (!isAdminAccount() && !isSuperadminAccount())))"
                :color="parseInt(status.value) === 1 ? 'green' : 'gray'"
                slot="activator"
                @click.native="onChangeStatus()"
              >
                <v-icon>account_circle</v-icon>
              </v-btn>
              <span>Activar/desactivar usuario</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                v-if="status.value < 3 && isSuperadmin() && (isSuperadminAccount() || isAdminAccount())"
                :color="this.roles[this.rol.value - 1] === 'superadmin' ? 'orange' : 'gray'"
                slot="activator"
                @click.native="onChangeRole()"
              >
                <v-icon>verified_user</v-icon>
              </v-btn>
              <span>Asignar/desasignar rol superadmin</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                v-if="status.value < 3 && (isSuperadmin() || isAdmin()) && isCommerceAccount()"
                :color="parseInt(calendar_visibility.value) === 1 ? 'green' : 'gray'"
                slot="activator"
                @click.native="onChangeCalendarVisibility()"
              >
                <v-icon>calendar_today</v-icon>
              </v-btn>
              <span>Mostrar/ocultar calendario de reservas</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                v-if="status.value < 3"
                color="primary"
                slot="activator"
                @click.native="renewPasswordDialog = true"
              >
                <v-icon>lock</v-icon>
              </v-btn>
              <span>Cambiar contraseña</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn
                fab
                dark
                v-if="false"
                small
                color="red"
                slot="activator"
              >
                <v-icon>delete</v-icon>
              </v-btn>
              <span>Eliminar usuario</span>
            </v-tooltip>
            <v-tooltip bottom>
              <div v-if="(isSuperadmin() || isAdmin()) && (isInstallerAccount() || isCommerceAccount())" @click="colorDialog = true" :style="{ backgroundColor: formattedColor }" slot="activator" class="account-color"></div>
              <span>Cambiar color</span>
            </v-tooltip>
          </div>
        </visible-for>
      </vuetify-avatar-card>

      <v-dialog v-model="renewPasswordDialog" max-width="350px">
        <v-card tile>
          <v-toolbar color="primary" dark>
            <v-toolbar-title>Cambiar contraseña</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
            <v-card-text>
              <v-layout column align-center justify-center>
                <vuetify-form-creator
                  ref="form_creator"
                  :columns="'xs12 sm12 md12 lg12'"
                  :items="password"
                  v-model="password"
                  :validate-on-changed="true"
                  @on-blur="onChange"
                ></vuetify-form-creator>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click.native="renewPasswordDialog = false">Cancelar</v-btn>
              <v-btn color="primary" flat @click.native="changePassword()">Cambiar</v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>

      <visible-for superadmin administrator supervisor installer>
        <vuetify-schedule-selector
          slot="content"
          v-if="isInstallerAccount()"
          :color="'primary'"
          :toolbar-title="'Disponibilidad'"
          :schedules="schedules || []"
          :value.sync="schedules"
          @on-add-schedule="addInstallerSchedule"
          @on-delete-schedule="deleteInstallerSchedule"
        >
        </vuetify-schedule-selector>
      </visible-for>
      
      <visible-for superadmin administrator supervisor installer>
        <vuetify-area-aggregator
          slot="content"
          v-if="isInstallerAccount()"
          :color="'primary'"
          :toolbar-title="'Áreas'"
          :list-title="'Agregar área'"
          :add-button-hover-text="'Pulsa para agregar una nueva área'"
          :dialog-max-width="670"
          :dialog-toolbar-title="'Agregar área'"
          :dialog-confirm-headline="'Eliminar área'"
          :dialog-confirm-text="'¿Seguro que quieres eliminar esta área?'"
          :cancel-button="'Cancelar'"
          :confirm-button="'Confirmar'"
          :delete-icon-hover-text="'Pulsa para eliminar'"
          :location-icon-hover-text="'Ver localización en Google'"
          :areas="areas || {}"
          :value.sync="areas"
          @on-add-area="addInstallerArea"
          @on-delete-area="deleteInstallerArea"
        >
        </vuetify-area-aggregator>
      </visible-for>

      <vuetify-phone-aggregator
        :color="'primary'"
        :toolbar-title="'Teléfonos'"
        :list-title="'Agregar teléfono'"
        :add-button-hover-text="'Pulsa para agregar un nuevo teléfono'"
        :dialog-max-width="450"
        :dialog-toolbar-title="'Agregar teléfono'"
        :text-field-label="'Teléfono'"
        :text-field-rules="phone.rules"
        :select-label="'Tipo'"
        :dialog-confirm-headline="'Eliminar teléfono'"
        :dialog-confirm-text="'¿Seguro que quieres eliminar este teléfono?'"
        :cancel-button="'Cancelar'"
        :confirm-button="'Confirmar'"
        :delete-button="((isManager() || isResponsible()) ? (isHisAccount() ? true : false) : true)"
        :navigation-menu="((isManager() || isResponsible()) ? (isHisAccount() ? true : false) : true)"
        :delete-icon-hover-text="'Pulsa para eliminar'"
        :phone-types="phone.types"
        :phones="phone.value || []"
        :value.sync="phone.value"
        @on-add-phone="onChangePhone"
        @on-delete-phone="onChangePhone"
      >
      </vuetify-phone-aggregator>
      
      <visible-for superadmin administrator>
        <vuetify-commerce-aggregator
          slot="content"
          :color="'primary'"
          v-if="isResponsibleAccount()"
          :toolbar-title="'Comercios'"
          :list-title="'Agregar comercio'"
          :add-button-hover-text="'Pulsa para agregar un nuevo comercio'"
          :dialog-max-width="400"
          :dialog-toolbar-title="'Agregar comercio'"
          :dialog-confirm-headline="'Eliminar comercio'"
          :dialog-confirm-text="'¿Seguro que quieres eliminar este comercio?'"
          :cancel-button="'Cancelar'"
          :confirm-button="'Confirmar'"
          :delete-icon-hover-text="'Pulsa para eliminar'"
          :location-icon-hover-text="'Ver localización en Google'"
          :commerces="assignedCommerces || []"
          :commerces-list="commercesList"
          :value.sync="assignedCommerces"
          @on-add-commerce="changeCommerces"
          @on-delete-commerce="changeCommerces"
        >
        </vuetify-commerce-aggregator>
      </visible-for>
      
      <visible-for superadmin administrator supervisor commerce manager>
        <vuetify-user-aggregator
          v-if="isCommerceAccount()"
          slot="content"
          :color="'primary'"
          :toolbar-title="'Vendedores'"
          :list-title="'Agregar vendedor'"
          :add-button-hover-text="'Pulsa para agregar un nuevo vendedor'"
          :dialog-max-width="450"
          :dialog-toolbar-title="'Agregar vendedor'"
          :no-data-text="'Vendedor'"
          :text-field-label="'Vendedor'"
          :text-field-rules="[]"
          :select-label="'Tipo'"
          :dialog-confirm-headline="'Eliminar vendedor'"
          :dialog-confirm-text="'¿Seguro que quieres eliminar este vendedor?'"
          :cancel-button="'Cancelar'"
          :delete-button="!isManager() && !isResponsible()"
          :navigation-menu="!isManager() && !isResponsible()"
          :confirm-button="'Confirmar'"
          :delete-icon-hover-text="'Pulsa para eliminar'"
          :users="sellers || []"
          :value.sync="sellers"
          @on-add-user="addCommerceSeller"
          @on-delete-user="deleteCommerceSeller"
        >
        </vuetify-user-aggregator>
      </visible-for>

      <vuetify-user-observation-aggregator
        v-if="!isNew() && (isSuperadmin() || isAdmin()) && parseInt(this.$store.getters['api/getUserId']) !== parseInt(userID.value)"
        :color="'primary'"
        :toolbar-title="'Observaciones'"
        :list-title="'Agregar observación'"
        :add-button-hover-text="'Pulsa para agregar una nueva observación'"
        :dialog-max-width="450"
        ref='observation_aggregator'
        :dialog-toolbar-title="'Agregar '"
        :delete-button="(isSuperadmin() || isAdmin())"
        :text-field-label="'Título'"
        :text-field-rules="observation.rules"
        :select-label="'Tipo'"
        :dialog-confirm-headline="'Eliminar observación'"
        :dialog-confirm-text="'¿Seguro que quieres eliminar esta observación?'"
        :cancel-button="'Cancelar'"
        :confirm-button="'Confirmar'"
        :delete-icon-hover-text="'Pulsa para eliminar'"
        :observations="observation.items || []"
        :value.sync="observation.value"
        @on-add-observation="onAddObservation"
        @on-delete-observation="deleteObservation"
      >
      </vuetify-user-observation-aggregator>

      <visible-for superadmin administrator supervisor>
        <vuetify-user-aggregator
          v-show="isCommerceAccount() && (isSuperadmin() || isAdmin())"
          slot="content"
          :color="'primary'"
          :toolbar-title="'Instaladores'"
          :list-title="'Agregar instalador'"
          :add-button-hover-text="'Pulsa para agregar un nuevo instalador'"
          :dialog-max-width="450"
          :dialog-toolbar-title="'Agregar instalador'"
          :text-field-label="'Instalador'"
          :text-field-rules="[]"
          :select-label="'Tipo'"
          :hidden-menu-when-no-options="true"
          :dialog-confirm-headline="'Eliminar instalador'"
          :no-data-text="'Vendedor'"
          :dialog-confirm-text="'¿Seguro que quieres eliminar este instalador?'"
          :cancel-button="'Cancelar'"
          :confirm-button="'Confirmar'"
          :add-on-enter="true"
          :return-object="true"
          :delete-icon-hover-text="'Pulsa para eliminar'"
          :users="installers.items || []"
          :value.sync="installers.items"
          :users-list="installersList"
          @on-add-user="addCommerceInstaller"
          @on-delete-user="deleteCommerceInstaller"
        >
        </vuetify-user-aggregator>
      </visible-for>
      <vuetify-signature-aggregator
        :color="'primary'"
        :toolbar-title="'Firma'"
        v-if="!isAdminAccount() && !isSuperadminAccount() && !isManagerAccount() && !isResponsibleAccount()"
        :list-title="'Agregar firma'"
        :navigation-menu="!isManager() && !isResponsible()"
        :add-button-hover-text="'Pulsa para agregar una nueva firma'"
        :dialog-max-width="670"
        :dialog-toolbar-title="'Agregar firma'"
        :dialog-confirm-headline="'Eliminar firma'"
        :dialog-confirm-text="'¿Seguro que quieres eliminar esta firma?'"
        :cancel-button="'Cancelar'"
        :confirm-button="'Confirmar'"
        :upload-icon-hover-text="'Subir imagen de 400 x 200 píxeles en formato PNG'"
        :clear-icon-hover-text="'Limpiar firma'"
        :save-icon-hover-text="'Guardar firma'"
        :delete-icon-hover-text="'Eliminar'"
        :options="signature || {}"
        :value.sync="signature.value"
        @on-upload-error="onUploadError"
        @on-add-signature="onChangeSignature"
        @on-delete-signature="onChangeSignature"
      >
      </vuetify-signature-aggregator>
      <vuetify-signature-aggregator
        :color="'primary'"
        :toolbar-title="'Sello'"
        :list-title="'Agregar sello'"
        v-if="isInstallerAccount()"
        :add-button-hover-text="'Pulsa para agregar un nuevo sello'"
        :dialog-max-width="670"
        :dialog-toolbar-title="'Agregar sello'"
        :dialog-confirm-headline="'Eliminar sello'"
        :dialog-confirm-text="'¿Seguro que quieres eliminar este sello?'"
        :cancel-button="'Cancelar'"
        :confirm-button="'Confirmar'"
        :upload-icon-hover-text="'Subir imagen de 400 x 200 píxeles en formato PNG'"
        :clear-icon-hover-text="'Limpiar sello'"
        :save-icon-hover-text="'Guardar sello'"
        :delete-icon-hover-text="'Eliminar'"
        :options="stamp || {}"
        :value.sync="stamp.value"
        @on-upload-error="onUploadError"
        @on-add-signature="onChangeStamp"
        @on-delete-signature="onChangeStamp"
      >
      </vuetify-signature-aggregator>
      </v-flex>

      <v-flex xs12 sm12 md7 lg7 xl7>
        
        <visible-for superadmin administrator supervisor installer commerce manager>
          <vuetify-editable-form-card
            ref="account"
            slot="content"
            :color="'primary'"
            :toolbar-title="'Cuenta'"
            :items="account"
            @on-change="onChange"
          ></vuetify-editable-form-card>
        </visible-for>

        <vuetify-editable-form-card
          ref="fields"
          :color="'primary'"
          :toolbar-title="getUserRol(rol.value) || ''"
          :items="fields"
          @on-change="onChange"
        ></vuetify-editable-form-card>

        <visible-for superadmin administrator supervisor installer
          v-if="isInstallerAccount()"
        >
          <vuetify-editable-form-card
            ref="company"
            slot="content"
            :color="'primary'"
            :toolbar-title="'Empresa'"
            :items="company"
            @on-change="onChange"
          ></vuetify-editable-form-card>
        </visible-for>
        
        <visible-for superadmin administrator supervisor commerce manager
          v-if="isCommerceAccount() || isManagerAccount()"
        >
          <vuetify-editable-form-card
            ref="corporation"
            slot="content"
            :color="'primary'"
            v-if="(isSuperadmin() || isAdmin())"
            :toolbar-title="'Empresa'"
            :items="corporation"
            @on-add-item="onAddItem"
            @on-change="onChange"
          ></vuetify-editable-form-card>
        </visible-for>

        <vuetify-editable-address-card
          ref="route"
          :color="'primary'"
          v-if="!isAdminAccount() && !isSuperadminAccount() && !isManagerAccount() && !isResponsibleAccount()"
          :toolbar-title="'Dirección de la empresa'"
          :dialog-toolbar-title="'Agregar dirección'"
          :placeholder="'Escribe tu dirección'"
          :list-title="'Agregar dirección'"
          :navigation-menu="!isManager() && !isResponsible()"
          :route="route"
          :routeExtras="routeExtras"
          :postalCode="postalCode"
          :locality="locality"
          :province="province"
          @on-change="onChange"
        ></vuetify-editable-address-card>
      </v-flex>
            <v-tooltip right>
              <v-btn
                v-if="(isSuperadmin() || isAdmin()) && parseInt(status.value) === 3"
                dark
                fab
                fixed
                bottom
                left
                slot="activator"
                color="red"
                @click="isInstallerAccount() ? returnToInstallers() : (isCommerceAccount() ? returnToCommerce() : (isManagerAccount() ? returnToManager() : (isResponsibleAccount() ? returnToResponsible() : returnToAdmin())))"
              >
                <v-icon>arrow_back</v-icon>
              </v-btn>
              <span>Salir sin guardar</span>
            </v-tooltip>
            <v-tooltip left>
              <v-btn
                v-if="status.value > 2"
                dark
                fab
                fixed
                bottom
                right
                slot="activator"
                color="green"
                @click="isInstallerAccount() ? validateInstaller() : (isCommerceAccount() ? validateCommerce() : (isManagerAccount() ? validateManager() : (isResponsibleAccount() ? validateResponsible() : validateAdmin())))"
              >
                <v-icon>check</v-icon>
              </v-btn>
              <span>Guardar</span>
            </v-tooltip>
    </v-layout>
    <v-dialog v-model="colorDialog" :max-width="isCommerceAccount() ? '350' : '77'">
      <chrome-picker v-if="isCommerceAccount()" v-model="colors" @input="updateColor"></chrome-picker>
      <v-card v-else>

      <v-tooltip bottom>
        <v-btn
          class="mx-2 color-pick"
          fab
          dark
          small
          slot="activator"
          @click="updateColor('rgba(213, 0, 0, 1)')"
          :style="{ backgroundColor: 'rgba(213, 0, 0, 1)' }"
        ></v-btn>
        <span>Tomate</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn
          class="mx-2 color-pick"
          fab
          dark
          small
          slot="activator"
          @click="updateColor('rgba(230, 124, 115, 1)')"
          :style="{ backgroundColor: 'rgba(230, 124, 115, 1)' }"
        ></v-btn>
        <span>Rosa chicle</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn
          class="mx-2 color-pick"
          fab
          dark
          small
          slot="activator"
          @click="updateColor('rgba(244, 81, 30, 1)')"
          :style="{ backgroundColor: 'rgba(244, 81, 30, 1)' }"
        ></v-btn>
        <span>Mandarina</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn
          class="mx-2 color-pick"
          fab
          dark
          small
          slot="activator"
          @click="updateColor('rgba(246, 191, 38, 1)')"
          :style="{ backgroundColor: 'rgba(246, 191, 38, 1)' }"
        ></v-btn>
        <span>Amarillo huevo</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn
          class="mx-2 color-pick"
          fab
          dark
          small
          slot="activator"
          @click="updateColor('rgba(51, 182, 121, 1)')"
          :style="{ backgroundColor: 'rgba(51, 182, 121, 1)' }"
        ></v-btn>
        <span>Verde esmeralda</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn
          class="mx-2 color-pick"
          fab
          dark
          small
          slot="activator"
          @click="updateColor('rgba(11, 128, 67, 1)')"
          :style="{ backgroundColor: 'rgba(11, 128, 67, 1)' }"
        ></v-btn>
        <span>Verde musgo</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn
          class="mx-2 color-pick"
          fab
          dark
          small
          slot="activator"
          @click="updateColor('rgba(3, 155, 229, 1)')"
          :style="{ backgroundColor: 'rgba(3, 155, 229, 1)' }"
        ></v-btn>
        <span>Azul turquesa</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn
          class="mx-2 color-pick"
          fab
          dark
          small
          slot="activator"
          @click="updateColor('rgba(63, 81, 181, 1)')"
          :style="{ backgroundColor: 'rgba(63, 81, 181, 1)' }"
        ></v-btn>
        <span>Azul arándano</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn
          class="mx-2 color-pick"
          fab
          dark
          small
          slot="activator"
          @click="updateColor('rgba(121, 134, 203, 1)')"
          :style="{ backgroundColor: 'rgba(121, 134, 203, 1)' }"
        ></v-btn>
        <span>Lavanda</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn
          class="mx-2 color-pick"
          fab
          dark
          small
          slot="activator"
          @click="updateColor('rgba(142, 36, 170, 1)')"
          :style="{ backgroundColor: 'rgba(142, 36, 170, 1)' }"
        ></v-btn>
        <span>Morado intenso</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn
          class="mx-2 color-pick"
          fab
          dark
          small
          slot="activator"
          @click="updateColor('rgba(97, 97, 97, 1)')"
          :style="{ backgroundColor: 'rgba(97, 97, 97, 1)' }"
        ></v-btn>
        <span>Grafito</span>
      </v-tooltip>
      

      </v-card>
    </v-dialog>
  </v-container>

</template>

<script>
  import api from 'config/api'
  import VuetifyFormCreator from '@/components/vuetify-form-creator/vuetify-form-creator'
  import VuetifyTextField from '@/components/vuetify-form-creator/fields/vuetify-text-field'
  import Rule from 'mixins/rule'
  import VuetifyPhoneAggregator from '@/components/vuetify-phone-aggregator'
  import VuetifyUserAggregator from '@/components/vuetify-user-aggregator'
  import VuetifyCommerceAggregator from '@/components/vuetify-commerce-aggregator'
  import VuetifyAreaAggregator from '@/components/vuetify-area-aggregator'
  import VuetifySignatureAggregator from '@/components/vuetify-signature-aggregator'
  import VuetifyScheduleSelector from '@/components/vuetify-schedule-selector'
  import VuetifyAvatarCard from '@/components/vuetify-avatar-card'
  import VuetifyUserObservationAggregator from '@/components/vuetify-user-observation-aggregator'
  import VuetifyEditableAddressCard from '@/components/vuetify-editable-address-card'
  import VuetifyEditableFormCard from '@/components/vuetify-editable-form-card'
  import VisibleFor from '@/components/vue-user/visible-for'
  import { Chrome } from 'vue-color'

  export default {
    mixins: [Rule],

    components:
    {
      VuetifyFormCreator,
      VuetifyTextField,
      VuetifyPhoneAggregator,
      VuetifyAreaAggregator,
      VuetifyUserObservationAggregator,
      VuetifySignatureAggregator,
      VuetifyScheduleSelector,
      VuetifyAvatarCard,
      VuetifyEditableAddressCard,
      VuetifyEditableFormCard,
      VuetifyUserAggregator,
      VuetifyCommerceAggregator,
      VisibleFor,
      'chrome-picker': Chrome
    },

    data () {
      return {
        alias: {},
        afterPromises: [],
        colors: [],
        status: {},
        installerColor: {},
        commerceColor: {},
        observations: {},
        businnes: null,
        clickTimer: null,
        avatar: {},
        name: {},
        observation: {
          type: 'select',
          assign_to: 'assignTo',
          editable: true,
          columns: 'xs12',
          label: 'Vendedor',
          item_text: 'seller_name',
          item_value: 'seller_id',
          items: [],
          rules: [],
          return_object: true,
          autocomplete: true
        },
        formattedColor: 'red',
        surname: {},
        username: {},
        password: [],
        renewPasswordDialog: false,
        colorDialog: false,
        schedules: [],
        commercesList: [],
        areas: {},
        businessName: {},
        phone: {},
        signature: {},
        calendar_visibility: {},
        stamp: {},
        account: [],
        fields: [],
        company: [],
        address: {
          dialog: false
        },
        assignedCommerces: [],
        route: {},
        routeExtras: {},
        postalCode: {},
        locality: {},
        province: {},
        corporation: [],
        companyID: {},
        commerceType: {},
        commerceID: {},
        responsibleID: {},
        commerces: {},
        companies: {},
        userID: {},
        AdminID: {},
        isSuper: {},
        sellers: [],
        installers: {},
        installersList: [],
        avatars: [],
        rol: {},
        roles: api.roles,
        display: false,
        path: this.$route.path.toLowerCase()
      }
    },

    created () {
      this.getProfile().then((response) => {
        console.log(response)
        this.normalizeAndAssign(response.data)
        if (this.isResponsibleAccount()) {
          this.assignedCommerces = JSON.parse(this.commerces.value)
        }
        this.getObservations().then((response) => {
          console.log(response)
          // console.log('·····dd···', this.roles[this.rol.value - 1])

          if (!this.isNew() && (this.isSuperadmin() || this.isAdmin())) {
            if (!(this.isInstallerAccount() || this.isCommerceAccount() || this.isAdminAccount() || this.isSuperadminAccount() || this.isManagerAccount() || this.isResponsibleAccount())) {
              this.$awn.alert('No se ha podido acceder a este perfil')
              return setTimeout(() => { this.$router.go(-1) }, 4000)
            }
          }

          if (!this.isNew() && this.$route.params.username !== 'me' && this.$route.params && (this.username.value !== this.$route.params.username)) {
            this.$awn.alert('No se ha podido acceder a este perfil')
            return setTimeout(() => { this.$router.go(-1) }, 4000)
          }
          this.normalizePassword()
          let url = this.avatar.default
          this.avatar.src = this.avatar.value || this.avatar.default + '0.png'
          for (let i = 0; i < 50; i++) {
            this.avatars.push({ src: url + i + '.png' })
          }
          let status = parseInt(this.status.value)
          if (status !== 3) {
            delete this.account[2]
          }

          if (this.corporation[0] && parseInt(this.corporation[0].value) === 1) {
            this.corporation[0].value = ''
          }
          if (this.corporation[1] && parseInt(this.corporation[1].value) === 1) {
            this.corporation[1].value = ''
          }
          if (this.corporation[2] && parseInt(this.corporation[2].value) === 1) {
            this.corporation[2].value = ''
          }
          if (this.corporation[3] && parseInt(this.corporation[3].value) === 1) {
            this.corporation[3].value = ''
          }

          console.log('this.corporation', this.corporation)

          if (this.isManager() || this.isResponsible()) {
            this.avatar.show_only = !this.isHisAccount()
            this.account[0].disabled = !this.isHisAccount()
            this.account[1].disabled = !this.isHisAccount()
            this.fields[0].disabled = true
            this.fields[1].disabled = true
            this.fields[2].disabled = true
            this.route.disabled = true
            this.routeExtras.disabled = true
            this.postalCode.disabled = true
            this.locality.disabled = true
            this.province.disabled = true
            /*
            this.installationInfo[4].type = 'hidden'
            this.customer[0].disabled = true
            this.customer[1].disabled = true
            this.customer[2].disabled = true
            this.customer[3].disabled = true
            this.installationStateForm[0].disabled = true
            this.installationStateCausesForm[0].disabled = true
            this.fields[0].disabled = true
            this.fields[0].type = 'text-field'
            this.fields[1].disabled = true
            this.fields[1].type = 'text-field'
            this.fields[2].disabled = true
            this.fields[2].type = 'text-field'
            this.fields[3].disabled = true
            this.fields[3].type = 'text-field'
            this.fields[4].disabled = true
            this.fields[4].type = 'text-field'
            this.fields[5].disabled = true
            this.fields[5].type = 'text-field'
            this.fields[5].value = this.fields[5].value.seller_name
            this.route.disabled = true
            this.routeExtras.disabled = true
            this.postalCode.disabled = true
            this.locality.disabled = true
            this.province.disabled = true
            this.routeDelivery.disabled = true
            this.routeExtrasDelivery.disabled = true
            this.postalCodeDelivery.disabled = true
            this.localityDelivery.disabled = true
            this.provinceDelivery.disabled = true
            */
          }
          this.getCommerces().then((response) => {
            this.commercesList = response.data.items || []
            console.log('COMMERCES', response.data.items)
            this.installerInit(status)
            this.commerceInit(status)
            this.adminInit(status)
            this.managerInit(status)
            this.responsibleInit(status)
            this.formattedColor = this.isCommerceAccount() ? (this.commerceColor.value || 'white') : (this.installerColor.value || 'white')
          }).catch((error) => {
            console.log(error)
          })
        }).catch((error) => {
          console.log(error)
        })
      }).catch((error) => {
        console.log(error)
      })
    },

    methods:
    {
      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isNew () {
        if (this.$route.params.username) {
          return false
        } else {
          return true
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      normalizeAndAssign (params) {
        let filter = (param, def) => {
          return (typeof param !== 'undefined') ? param : def
        }
        params.map((obj, index) => {
          obj.label = filter(obj.label, undefined)
          obj.ref = filter(obj.ref, '')
          obj.order = filter(obj.order, '')
          obj.assign_to = filter(obj.assign_to, 'fields')
          obj.value_class = filter(obj.value_class, '')
          obj.tooltip = filter(obj.tooltip, 'Pulsa para editar')
          obj.hint = filter(obj.hint, 'Pulsa enter para guardar')
          obj.focusNextOnEnter = filter(obj.focusNextOnEnter, true)
          obj.dark = filter(obj.dark, false)
          obj.color = filter(obj.color, 'primary')
          obj.columns = filter(obj.columns, 'xs12 sm6 md6 lg6')
          obj.counter = filter(obj.counter, false)
          obj.dialog = filter(obj.dialog, false)
          obj.editable = filter(obj.editable, true)
          obj.data_type = filter(obj.data_type, 'str')
          obj.required = filter(obj.required, true)
          obj.disabled = filter(obj.disabled, false)
          obj.type = filter(obj.type, 'text-field')
          obj.autocomplete = filter(obj.autocomplete, obj.ref)
          obj.rules = this.setRules(obj.rules)
          let assignTo = Array.isArray(obj.assign_to) ? obj.assign_to : [obj.assign_to]

          assignTo.forEach((item) => {
            if (Array.isArray(this[item])) {
              this[item].push(obj)
            } else {
              this[item] = obj
            }
          })
          return obj
        })
        return params
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      normalizePassword () {
        let fields = [
          {
            type: 'password',
            columns: 'xs12',
            label: (this.isSuperadmin() || this.isAdmin()) ? 'Nueva contraseña' : 'Contraseña actual',
            assign_to: 'password',
            autocomplete: 'password',
            dialog: false,
            editable: false,
            hint: '',
            rules: [
              'required'
            ]
          },
          {
            type: 'password',
            columns: 'xs12',
            label: (this.isSuperadmin() || this.isAdmin()) ? 'Repetir contraseña' : 'Nueva contraseña',
            assign_to: 'password',
            autocomplete: 'password',
            dialog: false,
            editable: false,
            hint: '',
            rules: [
              'required'
            ]
          }
        ]

        this.normalizeAndAssign(fields)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      validateInstaller () {
        let account = this.$refs.account.$refs.form_creator.validateForm()
        let fields = this.$refs.fields.$refs.form_creator.validateForm()
        let company = this.$refs.company.$refs.form_creator.validateForm()
        let route = this.$refs.route.$refs.form_creator.validateForm()
        // console.log(this.schedules)
        if (account && fields && company && route) {
          if (this.phone.value.length === 0) {
            return this.$awn.warning('Debes agregar al menos un teléfono')
          } else if (this.areas.length === 0) {
            return this.$awn.warning('Debes agregar al menos un área de trabajo')
          } else if (!this.signature.value) {
            return this.$awn.warning('Debes agregar una firma')
          } else if (!this.stamp.value) {
            return this.$awn.warning('Debes agregar un sello de empresa')
          } else if ((this.schedules[0].selected.length + this.schedules[1].selected.length) === 0) {
            return this.$awn.warning('Debes habilitar al menos un horario')
          }
          this.status.value = '2'
          this.onChange(this.status.value, null, this.status, true)
          this.$router.push({
            name: 'account',
            params: {
              username: this.username.value
            }
          })
        } else {
          this.$awn.warning('Debes completar todos los campos requeridos')
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      validateCommerce () {
        let account = this.$refs.account.$refs.form_creator.validateForm()
        let fields = this.$refs.fields.$refs.form_creator.validateForm()

        let corporation = true
        if ((this.isSuperadmin() || this.isAdmin())) {
          corporation = this.$refs.corporation.$refs.form_creator.validateForm()
        }

        let route = this.$refs.route.$refs.form_creator.validateForm()
        if (account && fields && corporation && route) {
          if (this.phone.value.length === 0) {
            return this.$awn.warning('Debes agregar al menos un teléfono')
          } else if (this.sellers.length === 0) {
            return this.$awn.warning('Debes agregar al menos un vendedor')
          } else if (!this.signature.value) {
            return this.$awn.warning('Debes agregar una firma')
          }
          this.status.value = '2'
          this.onChange(this.status.value, null, this.status, true)
          this.$router.push({
            name: 'account',
            params: {
              username: this.username.value
            }
          })
        } else {
          this.$awn.warning('Debes completar todos los campos requeridos')
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      validateAdmin () {
        let account = this.$refs.account.$refs.form_creator.validateForm()
        let fields = this.$refs.fields.$refs.form_creator.validateForm()
        if (account && fields) {
          this.status.value = '2'
          this.onChange(this.status.value, null, this.status, true)
          this.$router.push({
            name: 'account',
            params: {
              username: this.username.value
            }
          })
        } else {
          this.$awn.warning('Debes completar todos los campos requeridos')
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      validateManager () {
        let account = this.$refs.account.$refs.form_creator.validateForm()
        let fields = this.$refs.fields.$refs.form_creator.validateForm()
        let corporation = true
        if ((this.isSuperadmin() || this.isAdmin())) {
          corporation = this.$refs.corporation.$refs.form_creator.validateForm()
        }
        if (account && fields && corporation) {
          this.status.value = '2'
          this.onChange(this.status.value, null, this.status, true)
          this.$router.push({
            name: 'account',
            params: {
              username: this.username.value
            }
          })
        } else {
          this.$awn.warning('Debes completar todos los campos requeridos')
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      validateResponsible () {
        let account = this.$refs.account.$refs.form_creator.validateForm()
        let fields = this.$refs.fields.$refs.form_creator.validateForm()
        if (!this.commerces.value) {
          this.$awn.warning('Debes asignar al menos un comercio a este encargado.')
        } else if (this.commerces.value && account && fields) {
          this.status.value = '2'
          this.onChange(this.status.value, null, this.status, true)
          this.$router.push({
            name: 'account',
            params: {
              username: this.username.value
            }
          })
        } else {
          this.$awn.warning('Debes completar todos los campos requeridos')
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      returnToInstallers () {
        this.$router.push(
          {
            name: 'installers'
          }
        )
        this.deleteUser(this.userID.value)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      returnToResponsible () {
        this.$router.push(
          {
            name: 'responsibles'
          }
        )
        this.deleteUser(this.userID.value)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      returnToManager () {
        this.$router.push(
          {
            name: 'managers'
          }
        )
        this.deleteUser(this.userID.value)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      returnToCommerce () {
        this.$router.push(
          {
            name: 'commerces'
          }
        )
        this.deleteUser(this.userID.value)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      returnToAdmin () {
        this.$router.push(
          {
            name: 'admins'
          }
        )
        this.deleteUser(this.userID.value)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      deleteUser (userID) {
        this.$store.dispatch('api/authRequest', {
          method: 'delete',
          url: 'user/profile/' + userID + '/'
        }).then((response) => {
          // console.log(response.data)
        }).catch((error) => {
          console.log(error)
          let message = this.$store.getters['api/getMessage']
          this.$awn.alert('Error al guardar: ' + message)
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getCommerces () {
        return new Promise((resolve, reject) => {
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'user/commerces/'
          }).then((response) => {
            console.log(response.data)
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.$store.dispatch(
              'snackbar/show',
              'Error al obtener el perfil: ' + this.$store.getters['api/getMessage']
            )
            reject(error.response)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getProfile () {
        return new Promise((resolve, reject) => {
          let url = ''
          if (this.$route.params.username) {
            url = `user/profile/${this.$route.params.username}/`
          } else {
            url = `user/new/${this.$route.params.type}/`
          }
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: url
          }).then((response) => {
            // console.log('USER', response)
            resolve(response)
          }).catch((error) => {
            console.log(error)
            // let message = this.$store.getters['api/getMessage']
            this.$awn.alert('No se ha podido acceder a este perfil')
            reject(error.response)
            setTimeout(() => { this.$router.go(-1) }, 4000)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      installerInit (status) {
        if (this.isInstallerAccount()) {
          this.getInstallationAreas().then((response) => {
            this.areas = response.data
            this.getInstallerSchedules().then((response) => {
              this.schedules = response.data
              this.display = true
              if (status === 3 && !(this.isSuperadmin() || this.isAdmin())) {
                this.$awn.tip('Debes completar tu perfil para poder acceder al resto del sistema')
              } else if (status === 2 && !(this.isSuperadmin() || this.isAdmin())) {
                this.$awn.tip('Un administrador debe revisar tu perfil para poder acceder al resto del sistema')
              }
            }).catch((error) => {
              console.log(error)
            })
          }).catch((error) => {
            console.log(error)
          })
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      managerInit (status) {
        if (this.isManagerAccount()) {
          this.display = true
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      responsibleInit (status) {
        if (this.isResponsibleAccount()) {
          this.display = true
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      adminInit (status) {
        if (this.isAdminAccount() || this.isSuperadminAccount()) {
          this.display = true
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isSuperadminAccount () {
        return this.roles[this.rol.value - 1] === 'superadmin'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isAdminAccount () {
        return this.roles[this.rol.value - 1] === 'administrator'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isManagerAccount () {
        return this.roles[this.rol.value - 1] === 'manager'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isResponsibleAccount () {
        return this.roles[this.rol.value - 1] === 'responsible'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isInstallerAccount () {
        return this.roles[this.rol.value - 1] === 'installer'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isCommerceAccount () {
        return this.roles[this.rol.value - 1] === 'commerce'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isSuperadmin () {
        return this.$store.getters['api/getUserRol'] === 'superadmin'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isManager () {
        return this.$store.getters['api/getUserRol'] === 'manager'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isResponsible () {
        return this.$store.getters['api/getUserRol'] === 'responsible'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isAdmin () {
        return this.$store.getters['api/getUserRol'] === 'administrator'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getInstallationAreas () {
        return new Promise((resolve, reject) => {
          let userID = this.userID.value
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'user/installer/installation/area/' + userID + '/'
          }).then((response) => {
            // console.log(response.data)
            resolve(response)
          }).catch((error) => {
            console.log(error)
            let message = this.$store.getters['api/getMessage']
            this.$awn.alert('Error al obtener el perfil: ' + message)
            reject(error.response)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      changeCommerces (currentCommerces) {
        this.commerces.value = currentCommerces
        this.updateItem(this.commerces, JSON.stringify(currentCommerces))
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      deleteInstallerArea (item) {
        // console.log(item)
        this.$store.dispatch('api/authRequest', {
          method: 'delete',
          url: 'user/installer/installation/area/' + item.area_id + '/'
        }).then((response) => {
          // console.log(response)
          if (this.status.value < 3) {
            this.$awn.success('Área eliminada')
          }
        }).catch(() => {
          let message = this.$store.getters['api/getMessage']
          this.$awn.alert('Error al eliminar el área: ' + message)
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getInstallerSchedules () {
        return new Promise((resolve, reject) => {
          let userID = this.userID.value
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'user/installer/schedules/' + userID + '/'
          }).then((response) => {
            // console.log(response.data)
            resolve(response)
          }).catch((error) => {
            console.log(error)
            let message = this.$store.getters['api/getMessage']
            this.$awn.alert('Error al obtener el perfil: ' + message)
            reject(error.response)
          })
        })
      },

      /**
       * Get theme style.
       *pause_circle_filled
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      addInstallerSchedule (item, selected) {
        let userID = this.userID.value
        this.$store.dispatch('api/authRequest', {
          method: 'post',
          url: 'user/installer/schedules/' + userID + '/',
          data: {
            schedule_id: item.value
          }
        }).then((response) => {
          // console.log(response)
          item.id = response.data
          selected.push(item.value)
          if (this.status.value < 3) {
            this.$awn.success('Horario agregado')
          }
        }).catch((error) => {
          console.log(error)
          let message = this.$store.getters['api/getMessage']
          this.$awn.alert('Error al guardar: ' + message)
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      deleteInstallerSchedule (index, item, selected) {
        this.$store.dispatch('api/authRequest', {
          method: 'delete',
          url: 'user/installer/schedules/' + item.id + '/'
        }).then((response) => {
          selected.splice(index, 1)
          if (this.status.value < 3) {
            this.$awn.success('Horario eliminado')
          }
        }).catch((error) => {
          console.log(error)
          let message = this.$store.getters['api/getMessage']
          this.$awn.alert('Error al eliminar la disponibilidad: ' + message)
        })
      },

      /**
       * Get theme style.
       *pause_circle_filled
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      addCommerceSeller (item) {
        this.$store.dispatch('api/authRequest', {
          method: 'post',
          url: 'user/commerce/sellers/' + this.commerceID.value + '/',
          data: {
            seller_id: item.id,
            seller_avatar: item.avatar,
            seller_gender: item.gender,
            seller_name: item.name
          }
        }).then((response) => {
          // console.log(response)
          if (this.status.value < 3) {
            this.$awn.success('Vendedor agregado')
          }
          item.id = response.data
          this.sellers.push(item)
        }).catch((error) => {
          console.log(error)
          let message = this.$store.getters['api/getMessage']
          this.$awn.alert('Error al guardar: ' + message)
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      deleteCommerceSeller (item, index) {
        this.$store.dispatch('api/authRequest', {
          method: 'delete',
          url: 'user/commerce/sellers/' + item.id + '/'
        }).then((response) => {
          this.sellers.splice(index, 1)
          if (this.status.value < 3) {
            this.$awn.success('Vendedor eliminado')
          }
          // console.log(response)
        }).catch((error) => {
          console.log(error)
          this.$awn.alert('Este vendedor está asignado a alguna reserva y no puedes eliminarlo.')
        })
      },

      /**
       * Get theme style.
       *pause_circle_filled
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      addCommerceInstaller (item) {
        if (!this.installers.value) {
          this.installers.value = []
        }
        this.installers.value.push(parseInt(item.id))
        this.onChange(JSON.stringify(this.installers.value), null, this.installers, true)
        this.installers.value = JSON.parse(this.installers.value)
        this.getInstallersItems()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      deleteCommerceInstaller (item, index) {
        let theIndex = this.installers.value.indexOf(parseInt(item.id))
        this.installers.value.splice(theIndex, 1)
        this.installers.items.splice(index, 1)
        this.installersList.push(item)
        this.onChange(JSON.stringify(this.installers.value), null, this.installers, true)
        this.installers.value = JSON.parse(this.installers.value)
        this.getInstallersItems()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      commerceInit (status) {
        if (this.isCommerceAccount()) {
          this.getCommerceSellers().then((response) => {
            this.sellers = this.normalizeSellers(response.data)
            if ((this.isSuperadmin() || this.isAdmin())) {
              this.getInstallers().then((response) => {
                this.installers.all = this.normalizeInstallers(response.data)
                this.getInstallersItems()
                if (status === 3 && this.installers.all.length === 0) {
                  // return this.$awn.warning('Debes agregar instaladores antes de editar o crear comercios')
                }
                this.display = true
              }).catch((error) => {
                console.log(error)
              })
              // console.log(status)
            } else {
              this.display = true
            }
            if (status === 3 && !(this.isSuperadmin() || this.isAdmin())) {
              this.$awn.tip('Debes completar tu perfil para poder acceder al resto del sistema')
            } else if (status === 2 && !(this.isSuperadmin() || this.isAdmin())) {
              this.$awn.tip('Un administrador debe revisar tu perfil para poder acceder al resto del sistema')
            }
          }).catch((error) => {
            console.log(error)
          })
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      normalizeInstallers (params) {
        this.installers.items = []
        params.items.map((obj, index) => {
          obj.id = obj[params.item_value]
          obj.name = obj[params.item_text_12]
          obj.avatar = obj[params.item_text_4]
          return obj
        })
        return params.items
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getInstallersItems () {
        this.installersList = this.installers.all
        for (let installerID in this.installers.value) {
          let id = this.installers.value[installerID]
          let index = this.installersList.findIndex(
            item => parseInt(item.id) === parseInt(id)
          )
          if (index > -1) {
            this.installers.items.push(this.installersList[index])
            this.installersList.splice(index, 1)
          }
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getCommerceSellers () {
        return new Promise((resolve, reject) => {
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'user/commerce/sellers/' + this.commerceID.value + '/'
          }).then((response) => {
            // console.log(response)
            resolve(response)
          }).catch((error) => {
            console.log(error)
            let message = this.$store.getters['api/getMessage']
            this.$awn.alert('Error al obtener el perfil: ' + message)
            reject(error.response)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      normalizeSellers (params) {
        params.map((obj, index) => {
          obj.id = obj.seller_id
          obj.avatar = obj.seller_avatar
          obj.gender = obj.seller_gender
          obj.name = obj.seller_name
          return obj
        })
        return params
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getInstallers () {
        return new Promise((resolve, reject) => {
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'user/installers/'
          }).then((response) => {
            // console.log('sssssssss', response.data)
            resolve(response)
          }).catch((error) => {
            console.log(error)
            let message = this.$store.getters['api/getMessage']
            this.$awn.alert('Error al obtener el perfil: ' + message)
            reject(error.response)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getCorporateInformation () {
        return new Promise((resolve, reject) => {
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'user/commerce/corporate-information/'
          }).then((response) => {
            resolve(response)
          }).catch((error) => {
            console.log(error)
            let message = this.$store.getters['api/getMessage']
            this.$awn.alert('Error al obtener el perfil: ' + message)
            reject(error.response)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getUserRol (rolID) {
        let roles = [
          'Superadmin',
          'Administrador',
          'Supervisor',
          'Comercio',
          'Instalador',
          'Invitado',
          'Gerente',
          'Encargado'
        ]
        return roles[rolID - 1]
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChangeStatus () {
        let userID = parseInt(this.userID.value)
        if (userID === 3 || this.isHisAccount()) {
          return this.$awn.alert('No puedes modificar el estado de este usuario.')
        }
        let status = parseInt(this.status.value) === 1 ? 2 : 1
        this.status.value = status
        this.onChange(this.status.value, null, this.status, true)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isHisAccount () {
        return parseInt(this.userID.value) === parseInt(this.$store.getters['api/getUserId'])
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChangeCalendarVisibility () {
        this.calendar_visibility.value = parseInt(this.calendar_visibility.value) === 1 ? 0 : 1
        this.onChange(this.calendar_visibility.value, null, this.calendar_visibility, true)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChangeRole () {
        if (parseInt(this.userID.value) === 3) {
          return this.$awn.alert('No puedes modificar los privilegios de este usuario.')
        }
        this.rol.value = parseInt(this.rol.value) === 1 ? 2 : 1
        this.onChange(this.rol.value, null, this.rol, true)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChangePhone () {
        this.onChange(JSON.stringify(this.phone.value), null, this.phone, true)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChangeSignature () {
        this.onChange(this.signature.value, null, this.signature, true)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChangeStamp () {
        this.onChange(this.stamp.value, null, this.stamp, true)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChangeAvatar (item) {
        item.value = item.src
        this.onChange(item.src, null, item, true)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onUploadError (type, requiredValue) {
        let errors = {
          'format': 'ERROR: La imagen debe tener un formato: ' + requiredValue,
          'max-file-size': 'ERROR: La imagen no debe superar los ' + (requiredValue / 1000) + 'kB',
          'width': 'ERROR: La imagen debe tener un ancho de ' + requiredValue + 'px',
          'height': 'ERROR: La imagen debe tener un alto de ' + requiredValue + 'px'
        }
        this.$awn.alert(errors[type])
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChange (newVal, oldVal, item, isValid) {
        if (this.$store.getters['api/getStatus'] !== 'loading') {
          if (this.display && isValid) {
            if (item.business_relations && this.isManagerAccount()) {
              item.table = 'managers'
            }
            if (item.assign_to !== 'avatar' && item.assign_to !== 'phone') {
              item.value = newVal
            }
            if (item.type === 'text-field') {
              this.updateItem(item, item.value)
            } else if (newVal && item.type === 'select') {
              this.updateItem(item, newVal[item.item_value])
              item.value = newVal
            } else if (item.ref === 'password' && isValid) {
              this.updateItem(item, item.value)
            }
          }
        }
        if (item.business_relations && this.isCommerceAccount()) {
          this.normalizeBusiness(item)
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onAddItem (newVal, oldVal, item, isValid) {
        let userID = this.userID.value
        this.$store.dispatch('api/authRequest', {
          method: 'post',
          url: 'user/profile/' + userID + '/',
          data: {
            controller: item.item_controller,
            value: newVal
          }
        }).then((response) => {
          // console.log(response)
          let value = {
            [item.item_text]: newVal,
            [item.item_value]: response.data
          }
          item.items.unshift(value)
          item.value = item.items[0]
        }).catch((error) => {
          console.log(error)
          this.$awn.alert('Al agregar nuevo elemento')
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      normalizeBusiness (item) {
        let currentBrandID = item.value[item.item_value]

        if (item.business_relations[currentBrandID]) {
          if (!this.businnes) {
            this.businnes = this.corporation[3].items
          }
          let brandModels = item.business_relations[currentBrandID]

          let items = []
          this.businnes.forEach(obj => {
            let modelID = obj[this.corporation[3].item_value]

            if (brandModels.indexOf(modelID) > -1) {
              items.push(obj)
            }
          })
          this.corporation[3].items = items
          this.corporation[3].value = items ? (this.corporation[3].value ? this.corporation[3].value : []) : []
        } else {
          this.corporation[3].items = []
          this.corporation[3].value = ''
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      updateItem (item, value) {
        let userID = this.userID.value
        this.$store.dispatch('api/authRequest', {
          method: 'put',
          url: 'user/profile/' + userID + '/',
          data: {
            table: item.table,
            column: item.column,
            data_type: item.data_type,
            value: value
          }
        }).then((response) => {
          // console.log(response)
          if (response.data && this.status.value < 3) {
            this.$awn.success('¡Hecho!')
          } else if (!response.data && this.status.value < 3) {
            let message = this.$store.getters['api/getMessage']
            this.$awn.alert('Error al guardar: ' + message)
          }
          // this.runPendingPromises()
        }).catch((error) => {
          console.log(error)
          let message = this.$store.getters['api/getMessage']
          this.$awn.alert('Error al guardar: ' + message)
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      changePassword () {
        if (this.$refs.form_creator.validateForm()) {
          if ((this.isSuperadmin() || this.isAdmin())) {
            if (this.password[0].value !== this.password[1].value) {
              return this.$awn.warning('Las contraseñas no coinciden')
            }
          }
          let userID = this.userID.value
          this.$store.dispatch('api/authRequest', {
            method: 'put',
            url: 'user/change-password/' + userID + '/',
            data: {
              old: this.password[0].value,
              new: this.password[1].value
            }
          }).then((response) => {
            // console.log(response)
            this.renewPasswordDialog = false
            this.password[0].value = ''
            this.password[1].value = ''
            this.$refs.form_creator.reset()
            if (this.status.value < 3) {
              this.$awn.success('Contraseña modificada')
            }
          }).catch((error) => {
            console.log(error)
            let message = this.$store.getters['api/getMessage']
            this.$awn.alert('Error: ' + message)
          })
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getObservations () {
        return new Promise((resolve, reject) => {
          if (!(this.isSuperadmin() || this.isAdmin())) {
            resolve(true)
            return true
          }
          let userID = this.userID.value
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'user/observations/' + userID + '/'
          }).then((response) => {
            this.observation.items = response.data
            // console.log(response)
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.$store.dispatch(
              'snackbar/show',
              'Error al obtener observaciones: ' + this.$store.getters['api/getMessage']
            )
            reject(error.response)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      updateColor (color) {
        this.formattedColor = color.rgba ? ('rgba(' + color.rgba.r + ',' + color.rgba.g + ',' + color.rgba.b + ',' + color.rgba.a + ')') : color
        clearTimeout(this.clickTimer)
        this.clickTimer = setTimeout(() => {
          console.log('updateColor')
          let item = this.isCommerceAccount() ? this.commerceColor : this.installerColor
          item.value = this.formattedColor
          this.updateItem(
            item,
            item.value
          )
        }, 1000)
        if (this.isInstallerAccount()) {
          this.colorDialog = false
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onAddObservation (item) {
        item.from_user_id = parseInt(this.$store.getters['api/getUserId'])
        item.to_user_id = parseInt(this.userID.value)
        // console.log('OBSERVATION', item)
        this.$store.dispatch('api/authRequest', {
          method: 'post',
          url: 'user/observations/',
          data: item
        }).then((response) => {
          // console.log('onAddObservation', response.data)
          item.user_observation_id = response.data
          item.user_observation_user = 'Tú'
          this.observation.items.push(item)
          if (!this.isNew()) {
            this.$awn.success('Observación agregada')
          }
        }).catch((error) => {
          console.log(error)
          let message = this.$store.getters['api/getMessage']
          this.$awn.alert('Error al agregar la nota: ' + message)
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      deleteObservation (index, item) {
        this.$store.dispatch('api/authRequest', {
          method: 'delete',
          url: 'user/observations/' + item.user_observation_id + '/'
        }).then((response) => {
          // console.log(response)
          this.observation.items.splice(index, 1)
          if (!this.isNew()) {
            this.$awn.success('Observación eliminada')
          }
        }).catch(() => {
          let message = this.$store.getters['api/getMessage']
          this.$awn.alert('Error al eliminar la observación: ' + message)
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      runPendingPromises () {
        this.afterPromises.reverse()
        this.afterPromises.forEach((promise, index) => {
          promise()
          this.afterPromises.splice(index, 1)
        })
      }
    },

    watch: {
      'username.value': {
        handler: function (newVal, oldVal) {
          this.afterPromises.push(() => {
            this.$router.push(
              {
                name: 'account',
                params: {
                  username: newVal
                }
              }
            )
          })
        }
      }
    }
  }
</script>

<style lang="sass">

.application
  background: rgba(63, 81, 181, 0.07058823529411765) !important

a
 text-decoration: none

.avatar 
  cursor: pointer

.flex
  /* padding: 5px 12px */

.container.grid-list-xl *:not(:only-child) .layout:first-child
  margin-top: 0px

.jst-card
  margin-bottom: 20px

.add-area

.carousel-actions
  padding: 18px

.carousel
  height: 250px
  width: 250px
  margin: 0 auto
  box-shadow: none

.input-file
  display: none

.avatar-info
  width: 72%

.add-address
  display: hidden

.address-autocomplete
  max-width: 435px
  margin: 0 auto
  padding: 32px 0 32px 0

.list-item
  display: inline-block
  margin-right: 10px

.list-enter-active, .list-leave-active
  transition: all 1s

.list-enter, .list-leave-to
  opacity: 0
  transform: translateY(30px)

html
  overflow-y: visible !important

.profile-options
  float: right
  bottom: 62px

.disable-area
  opacity: 0.5;
  pointer-events: none;
  cursor: default;
  text-decoration: none;
  -webkit-transition: opacity 1s ease-in-out;
  -moz-transition: opacity 1s ease-in-out;
  -ms-transition: opacity 1s ease-in-out;
  -o-transition: opacity 1s ease-in-out;
  transition: opacity 1s ease-in-out;

.list__tile__sub-title
  max-height: 40px !important

.vc-chrome
  width: 350px !important

.account-color
  width: 93px
  height: 14px
  border-radius: 11px
  cursor: pointer
  border-style: solid
  margin: 16px auto
  border-width: 1px
  border-color: rgba(172, 173, 178, 0.88)

.color-pick
  height: 20px !important
  width: 20px !important
</style>



// WEBPACK FOOTER //
// src/pages/account.vue